import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Chip,
    Avatar,
    IconButton,
    Tooltip
} from '@mui/material';
import {
    Calendar,
    ChevronRight,
    Home
} from 'react-feather';

const UpcomingVisits = ({ visits, count, openTicketDialog }) => {
    // Get staff initials for avatar
    const getInitials = (name) => {
        if (!name) return '?';
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    // Format date
    const formatDate = (dateString) => {
        try {
            return new Date(dateString).toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            console.error("Date formatting error:", error);
            return 'Invalid date';
        }
    };

    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: '10px',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                overflow: 'hidden',
                height: '100%'
            }}
        >
            <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.08)', bgcolor: '#F9FAFB' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                        <Calendar size={16} style={{ marginRight: 8, color: '#3B82F6' }} />
                        Upcoming Scheduled Visits
                    </Typography>
                    <Chip
                        label={count}
                        color="primary"
                        size="small"
                        sx={{ fontWeight: 600 }}
                    />
                </Box>
            </Box>
            <Box sx={{ p: 0 }}>
                {visits.map((ticket) => (
                    <Box
                        key={ticket.id}
                        sx={{
                            p: 2,
                            borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                            '&:last-child': { borderBottom: 'none' },
                            '&:hover': { bgcolor: '#F9FAFB', cursor: 'pointer' },
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                        onClick={() => openTicketDialog(ticket)}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar
                                sx={{
                                    width: 32,
                                    height: 32,
                                    fontSize: '0.875rem',
                                    mr: 1.5,
                                    bgcolor: '#3B82F6'
                                }}
                            >
                                <Calendar size={16} />
                            </Avatar>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {ticket.title}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                    <Typography variant="caption" color="textSecondary">
                                        {formatDate(ticket.scheduledDate)}
                                    </Typography>
                                    <Chip
                                        label={ticket.tenant?.unit}
                                        size="small"
                                        sx={{
                                            ml: 1,
                                            backgroundColor: '#E0E7FF',
                                            color: '#4F46E5',
                                            borderRadius: '4px',
                                            fontSize: '0.625rem',
                                            height: 20
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Chip
                                label={ticket.property?.name}
                                size="small"
                                icon={<Home size={12} />}
                                sx={{
                                    mr: 1,
                                    height: 24,
                                    bgcolor: '#F3F4F6',
                                    color: '#6B7280',
                                    '& .MuiChip-icon': { color: '#6B7280' }
                                }}
                            />
                            {ticket.assignedTo && (
                                <Tooltip title={`Assigned to ${ticket.assignedTo.name}`}>
                                    <Avatar
                                        sx={{
                                            width: 24,
                                            height: 24,
                                            fontSize: '0.75rem',
                                            mr: 1,
                                            bgcolor: '#10B981'
                                        }}
                                    >
                                        {getInitials(ticket.assignedTo.name)}
                                    </Avatar>
                                </Tooltip>
                            )}
                            <IconButton size="small">
                                <ChevronRight size={16} />
                            </IconButton>
                        </Box>
                    </Box>
                ))}
                {visits.length === 0 && (
                    <Box sx={{ p: 4, textAlign: 'center' }}>
                        <Typography variant="body2" color="textSecondary">
                            No upcoming scheduled visits
                        </Typography>
                    </Box>
                )}
            </Box>
        </Paper>
    );
};

export default UpcomingVisits;